import React, { useEffect, useState } from "react";
import { menuclose, menuopen } from "../utilities/images";
import profileimage from "../assets/avatarprofile.png";
import { Link } from "react-router-dom";

function Bookingnavbar() {
  const [openMenu, setOpenMenu] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= 0) {
      // Always show navbar at the top of the page
      setIsVisible(true);
    } else if (currentScrollY > lastScrollY) {
      // Scrolling down
      setIsVisible(false);
    } else if (currentScrollY < lastScrollY) {
      // Scrolling up
      setIsVisible(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, lastScrollY]);
  return (
    <div className={`navbar ${isVisible ? "visible" : "hidden"}`}>
      <div className='navbar-container'>
        <div className='navbar-logo-left'>
          <Link to='' className='navbar-logo'>
            ProfixExpress
          </Link>
        </div>
        {/* <div className='navbar-mobile'>
          <button onClick={() => setOpenMenu(!openMenu)}>
            <img src={openMenu ? menuopen : menuclose} alt='' />
          </button>
        </div> */}
        <div className='navbardd'>
          <button className='navbarprofilebtn'>
            <img src={profileimage} alt='' />
          </button>
        </div>
      </div>
      <div className='navbartheview'>
        <Link to='/client/my_task'>My tasks</Link>
        <Link to='/client/post-job'>Post a New Job</Link>
        <Link to='/browse-technicians'>Browse Technicians</Link>
        <Link to='/favorites'>Favorite Technicians</Link>
        <Link to='/wallet'>My Wallet</Link>
        <Link to='/notifications'>Notifications</Link>
        <Link to='/job-history'>Job History</Link>
        <Link to='/my-profile'>My Profile</Link>
        <Link to='/support'>Support</Link>
      </div>
    </div>
  );
}

export default Bookingnavbar;
